
		<div class="progress-circle">
			<svg viewBox="0 0 36 36" class="circular-chart" [ngClass]="fill">
				<path d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
				      class="circle-bg"
				      [attr.stroke]="bgColor"></path>
				<path d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
				      class="circle"
				      [attr.stroke-dasharray]=" value + ',100'"></path>
				<text x="18" y="20.35" class="percentage">
					{{value ? value.toFixed(2) : 0}}%
				</text>
			</svg>
		</div>
  